(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/article/assets/article-selectors.js') >= 0) return;  svs.modules.push('/components/tipsen/article/assets/article-selectors.js');
"use strict";

const _svs$components$tipse = svs.components.tipsen.constants,
  REDUCER_STATE_INIT = _svs$components$tipse.REDUCER_STATE_INIT,
  REDUCER_STATE_DONE = _svs$components$tipse.REDUCER_STATE_DONE,
  REDUCER_STATE_REJECTED = _svs$components$tipse.REDUCER_STATE_REJECTED;
const selectArticleIsDone = (state, articleId) => {
  const articleState = state.Articles && state.Articles[articleId] ? state.Articles[articleId].state : REDUCER_STATE_INIT;
  return articleState === REDUCER_STATE_DONE;
};
const selectArticleIsRejected = (state, articleId) => {
  const articleState = state.Articles && state.Articles[articleId] ? state.Articles[articleId].state : REDUCER_STATE_INIT;
  return articleState === REDUCER_STATE_REJECTED;
};
const selectArticleShouldShowSkeleton = (state, articleId) => !selectArticleIsDone(state, articleId) && !selectArticleIsRejected(state, articleId);
const selectArticle = (state, cacheKey) => {
  const article = state.Articles && state.Articles[cacheKey] ? state.Articles[cacheKey].article : undefined;
  return article;
};
setGlobal('svs.components.tipsen.article.selectors', {
  selectArticleIsDone,
  selectArticleIsRejected,
  selectArticleShouldShowSkeleton,
  selectArticle
});

 })(window);